import { X } from 'lucide-react';

interface BannerProps {
  setShowBanner: (value: boolean) => void;
}

const Banner = ({ setShowBanner }: BannerProps) => {
  return (
    <div className="flex items-center justify-center min-h-[40px] bg-background-overlay text-text-primary relative z-0 w-full sm:max-w-none px-4 sm:px-8">
      <h3 className="font-normal text-left text-sm sm:text-[15px] leading-relaxed sm:text-center py-2">
        This is a preview of the dialogues that can be reviewed, edited, and
        regenerated before creating the final podcast.
      </h3>

      <button
        type="button"
        title="close"
        onClick={() => setShowBanner(false)}
        className="absolute top-2 right-2 sm:right-6 p-1 hover:bg-gray-700/50 rounded-full transition-colors"
      >
        <X size={20} />
      </button>
    </div>
  );
};

export default Banner;
